import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import auth from "./app/auth";
import "./assets/css/maxar.css";
import "./assets/css/main.css";
import VueCompositionAPI from "@vue/composition-api";
import VueLogger, { StringifyObjectsHook } from "vue-logger-plugin";

axios.interceptors.request.use(
  function (config) {
    // not sure why we have to set the "common" header every time . . .
    config.headers.common = {
      ...config.headers.common,
      Authorization: auth.auth.getSignInUserSession().getAccessToken().jwtToken,
    };
    return config;
  },
  function (error) {
    Vue.prototype.$log.error("axois request error", error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    Vue.prototype.$log.debug(
      `axois response recieved from ${response.config.url}`,
      response.data
    );
    return response;
  },
  (error) => {
    Vue.prototype.$log.error("axois response error", error);

    if (Number.isInteger(error.config.retry) && error.config.retry > 0) {
      Vue.prototype.$log.debug(
        `retrying request... ${error.config.retry} ${
          error.config.retry === 1 ? "more retries" : "more retry"
        } left`,
        error
      );
      error.config.retry--;
      return axios.request(error.config);
    }

    if (error.message === "Network Error") {
      store.commit("ui/SHOW_SNACKBAR", {
        text: "Network Error, request failed to send",
        color: "error",
      });
    } else if (error.response.status === 401) {
      store.commit("ui/SHOW_UNAUTHORIZED");
    } else if (error.response.status === 403 || error.response.status === 404) {
      store.commit("ui/SHOW_DIALOG", {
        text: `${error.response.data.message || error.message}`,
        color: "error",
      });
    } else {
      store.commit("ui/SHOW_DIALOG", {
        text: `${error.response.data.message || error.message}`,
        color: "error",
      });
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);

const isProduction = process.env.NODE_ENV === "production";

// define options
const options = {
  enabled: true,
  consoleEnabled: true,
  level: process.env.VUE_APP_LOG_LEVEL || "error",
  callerInfo: true,
  beforeHooks: [StringifyObjectsHook],
};

Vue.use(VueLogger, options);

/*
// override base console logging functions
console.log = (...args) => Vue.prototype.$log.debug(...args);
console.info = (...args) => Vue.prototype.$log.info(...args);
console.warn = (...args) => Vue.prototype.$log.warn(...args);
console.error = (...args) => Vue.prototype.$log.error(...args);
*/
if (process.env.VUE_APP_LOG_LEVEL) {
  console.log(`setting log level to ${process.env.VUE_APP_LOG_LEVEL}...`);
  Vue.prototype.$log.apply({ level: process.env.VUE_APP_LOG_LEVEL });
} else {
  console.log(`env does NOT have a log level set...`);
}

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
